/* Maximal Museum — Shopify catalogue feed.

   Shopify is the source of truth for the words and figures around the
   membership. Razorpay still takes the money: see the note above PLANS in
   app.js, and applyCatalogue() there, which refuses any price that disagrees
   with what the Razorpay plan is configured to bill.

   SECURITY — the token below is a PUBLIC Storefront access token, the kind
   Shopify designs to ship inside a page. Never put an Admin API access token
   or an API secret key in this file: everything here is readable by anyone
   who views source, and an Admin token would hand them your customers,
   your orders and write access to the store.

   Storefront API scopes this needs, and nothing more:
     unauthenticated_read_product_listings
     unauthenticated_read_selling_plans      (only for the plan descriptions)

   Fill in domain + token and it starts working. Leave them blank and the site
   runs on the figures baked into app.js, which is exactly how it behaves now. */
(function(){
  "use strict";

  var SHOP = {
    /* the shop domain, not the primary one: maximalmuseum.com is a custom
       domain and can be repointed, this cannot */
    domain:  'maximal-museum.myshopify.com',
    /* public Storefront access token from the Headless channel. Public by
       design — it ships in this file and is meant to. Rotate it in
       Sales channels > Headless if it ever needs replacing. */
    token:   'ffa7e8f55da87997769c3ceede14b226',
    version: '2026-07',                 /* Storefront API version            */
    handle:  'the-bulletin',            /* the product's handle in Shopify   */
    /* which Shopify variant backs each membership here. Matched against the
       variant title, ignoring case and surrounding space. */
    variants: { quarterly:'Quarterly', annual:'Annual' },
    ttlMinutes: 30                      /* how long a good answer is reused  */
  };

  /* lets a build step or a staging page point this at a different store
     without editing the file */
  if (window.MM_SHOPIFY){
    for (var k in window.MM_SHOPIFY){
      if (Object.prototype.hasOwnProperty.call(window.MM_SHOPIFY, k)) SHOP[k] = window.MM_SHOPIFY[k];
    }
  }

  if (!SHOP.domain || !SHOP.token || !window.fetch) return;

  var CACHE = 'mm_catalogue';

  var QUERY = [
    'query catalogue($handle: String!) {',
    '  product(handle: $handle) {',
    '    variants(first: 20) {',
    '      nodes {',
    '        title',
    '        availableForSale',
    '        price { amount currencyCode }',
    '        note: metafield(namespace: "custom", key: "note") { value }',
    '      }',
    '    }',
    '  }',
    '}'
  ].join('\n');

  function norm(s){ return String(s == null ? '' : s).trim().toLowerCase(); }

  /* Shopify returns money as a decimal string in the shop's currency. The
     memberships are whole rupees, and app.js compares prices with ===, so a
     value carrying paise is deliberately left to fail that comparison rather
     than being rounded into agreement. */
  function toAmount(money){
    if (!money || money.amount == null) return null;
    var n = Number(money.amount);
    return isFinite(n) ? n : null;
  }

  function toPatch(product){
    if (!product || !product.variants || !product.variants.nodes) return null;
    var nodes = product.variants.nodes, patch = {}, found = 0;

    for (var id in SHOP.variants){
      if (!Object.prototype.hasOwnProperty.call(SHOP.variants, id)) continue;
      var want = norm(SHOP.variants[id]);
      for (var i=0;i<nodes.length;i++){
        var v = nodes[i];
        if (norm(v.title) !== want) continue;
        patch[id] = {
          name: v.title,
          price: toAmount(v.price),
          note: v.note && v.note.value ? v.note.value : null
        };
        if (v.availableForSale === false && window.console && console.warn){
          console.warn('[MM] Shopify marks the "' + v.title + '" variant unavailable, '
            + 'but the site is still selling it. Reconcile before it matters.');
        }
        found++;
        break;
      }
      if (!patch[id] && window.console && console.warn){
        console.warn('[MM] no Shopify variant titled "' + SHOP.variants[id]
          + '" on product "' + SHOP.handle + '" — that plan keeps its built-in copy.');
      }
    }
    return found ? patch : null;
  }

  function readCache(){
    try {
      var raw = JSON.parse(sessionStorage.getItem(CACHE));
      if (!raw || !raw.at || !raw.patch) return null;
      if (Date.now() - raw.at > SHOP.ttlMinutes * 60000) return null;
      return raw.patch;
    } catch(e){ return null; }
  }
  function writeCache(patch){
    try { sessionStorage.setItem(CACHE, JSON.stringify({ at:Date.now(), patch:patch })); } catch(e){}
  }

  function apply(patch){
    if (patch && window.MM && MM.applyCatalogue) MM.applyCatalogue(patch);
  }

  function fetchCatalogue(){
    /* a catalogue is a nicety, not the page. If Shopify is slow, blocked by an
       extension, or down, the built-in figures stand and nobody notices. */
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function(){ if (ctrl) ctrl.abort(); }, 6000);

    fetch('https://' + SHOP.domain + '/api/' + SHOP.version + '/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': SHOP.token
      },
      body: JSON.stringify({ query: QUERY, variables: { handle: SHOP.handle } }),
      signal: ctrl ? ctrl.signal : undefined
    })
      .then(function(r){
        if (!r.ok) throw new Error('Storefront API returned ' + r.status);
        return r.json();
      })
      .then(function(body){
        if (body.errors && body.errors.length) throw new Error(body.errors[0].message);
        var patch = toPatch(body.data && body.data.product);
        if (!patch) throw new Error('no product "' + SHOP.handle + '" in the response');
        writeCache(patch);
        apply(patch);
      })
      .catch(function(err){
        if (window.console && console.warn){
          console.warn('[MM] Shopify catalogue unavailable, using built-in copy — ' + err.message);
        }
      })
      .then(function(){ clearTimeout(timer); });
  }

  function start(){
    /* paint from cache first so a second page does not flicker, then refresh */
    var cached = readCache();
    if (cached) apply(cached);
    fetchCatalogue();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
